var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 12.006C9.796 12.006 8.002 10.212 8.002 8.006C8.002 5.801 9.796 4.006 12.002 4.006C14.208 4.006 16.002 5.801 16.002 8.006C16.002 10.212 14.208 12.006 12.002 12.006ZM12.002 6.006C10.899 6.006 10.002 6.902 10.002 8.006C10.002 9.109 10.899 10.006 12.002 10.006C13.105 10.006 14.002 9.109 14.002 8.006C14.002 6.902 13.105 6.006 12.002 6.006Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.002 20.006H4.002V19.006C4.002 15.473 7.292 13.006 12.002 13.006C16.712 13.006 20.002 15.473 20.002 19.006V20.006ZM6.161 18.006H17.844C17.246 16.198 15.011 15.006 12.003 15.006C8.995 15.006 6.759 16.198 6.161 18.006Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.76295b1b.svg";
export { ForwardRef as ReactComponent };